import type { PermissionId } from "@/modules/roles/domain/contracts/permissions";

/** Matches server default in `server/platform/config.ts` — keep client-safe (no server env). */
export const AUTH_REQUIRE_ADMIN_2FA_DEFAULT = true;

export const ADMIN_2FA_REQUIRED_PERMISSIONS = [
  "wallet:approve",
  "audit:read",
] as const satisfies readonly PermissionId[];

export function permissionsRequireAdmin2FA(
  permissions: readonly string[],
  requireAdmin2FA = AUTH_REQUIRE_ADMIN_2FA_DEFAULT,
): boolean {
  if (!requireAdmin2FA) return false;
  return ADMIN_2FA_REQUIRED_PERMISSIONS.some((p) => permissions.includes(p));
}

export function userMustSetupTwoFactor(input: {
  permissions: readonly string[];
  twoFactorEnabled?: boolean | null;
  requireAdmin2FA?: boolean;
}): boolean {
  return (
    permissionsRequireAdmin2FA(
      input.permissions,
      input.requireAdmin2FA ?? AUTH_REQUIRE_ADMIN_2FA_DEFAULT,
    ) && input.twoFactorEnabled !== true
  );
}
